<template>
  <div id="privateequity-content" v-if="page.privateequity && (page.privateequity.text_left_col || page.privateequity.text_right_col)" :class="{'active': currentPage == 'privateequity-content'}">
    <div class="section reduced-width">
      <div class="section__main">
        <div class="content">
          <div class="cols">
            <div class="col col_main" v-html="page.privateequity.text_left_col"></div>
            <div class="col col_extra" v-html="page.privateequity.text_right_col"></div>
          </div>
          <div class="diagram-container" :class="{'static': isIE()}">
            <div class="circles circles_1">
              <div class="circles__text">{{page.privateequity.text_circle_title_1}}</div>
              <div class="circles__container">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="circles circles_2">
              <span class="line">
                <svg width="250" height="3" viewBox="0 0 250 3" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="grad1" x1="0" y1="0" x2="250" y2="0" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#d4e3ec" offset="0" />
                        <stop stop-color="#ee2e22" offset="1" />
                    </linearGradient>
                  </defs>
                  <line x1="0" y1="0" x2="250" y2="0" stroke-width="3" stroke="url(#grad1)" stroke-dasharray="10, 5"/>
                </svg>
              </span>
              <div class="circles__text">{{page.privateequity.text_circle_title_2}}</div>
              <div class="circles__container">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="circles circles_3">
              <span class="line">
                <svg width="70" height="3" viewBox="0 0 70 3" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="grad2" x1="0" y1="0" x2="70" y2="0" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#d4e3ec" offset="0" />
                        <stop stop-color="#ee2e22" offset="1" />
                    </linearGradient>
                  </defs>
                  <line x1="0" y1="0" x2="70" y2="0" stroke-width="3" stroke="url(#grad2)" stroke-dasharray="10, 5"/>
                </svg>
              </span>
              <div class="circles__text">{{page.privateequity.text_circle_title_3}}</div>
              <div class="circles__container">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="circles circles_4">
              <span class="line">
                <svg width="95" height="3" viewBox="0 0 95 3" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="grad3" x1="0" y1="0" x2="95" y2="0" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#ee2e22" offset="0" />
                        <stop stop-color="#d4e3ec" offset="1" />
                    </linearGradient>
                  </defs>
                  <line x1="0" y1="0" x2="95" y2="0" stroke-width="3" stroke="url(#grad3)" stroke-dasharray="10, 5"/>
                </svg>
              </span>
              <div class="circles__text">{{page.privateequity.text_circle_title_4}}</div>
              <div class="circles__container">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="circles circles_5">
              <span class="line">
                <svg width="170" height="3" viewBox="0 0 170 3" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="grad4" x1="0" y1="0" x2="170" y2="0" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#ee2e22" offset="0" />
                        <stop stop-color="#d4e3ec" offset="1" />
                    </linearGradient>
                  </defs>
                  <line x1="0" y1="0" x2="170" y2="0" stroke-width="3" stroke="url(#grad4)" stroke-dasharray="10, 5"/>
                </svg>
              </span>
              <div class="circles__text">{{page.privateequity.text_circle_title_5}}</div>
              <div class="circles__container">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="circles circles_6">
              <span class="line">
                <svg width="360" height="3" viewBox="0 0 360 3" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="grad5" x1="0" y1="0" x2="360" y2="0" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#ee2e22" offset="0" />
                        <stop stop-color="#d4e3ec" offset="1" />
                    </linearGradient>
                  </defs>
                  <line x1="0" y1="0" x2="360" y2="0" stroke-width="3" stroke="url(#grad5)" stroke-dasharray="10, 5"/>
                </svg>
              </span>
              <div class="circles__text">{{page.privateequity.text_circle_title_6}}</div>
              <div class="circles__container">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
          </div>
          <div class="benefits">
            <div class="benefits__title" v-html="page.privateequity.text_benefits_title"></div>
            <div class="cols">
              <div class="col col_main" v-html="page.privateequity.text_benefits_left_col"></div>
              <div class="col col_extra" v-html="page.privateequity.text_benefits_right_col"></div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import browserDetect from '@/helpers/browserDetect';

export default {
  name: 'privateEquityContent',
  data() {
    return {
      isAnimated: false,
    };
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
  }),
  methods: {
    isActive() {
      const checkActive = this.currentPage === this.page.privateequity.$path;
      const animationTime = (this.page.privateequity.title.length * 70) + 1300;
      setTimeout(() => { if (checkActive) this.isAnimated = true; }, animationTime);
      return checkActive;
    },
    isIE() {
      const ieCheck = (browserDetect() === 'ie');
      return ieCheck;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@keyframes rotate {
  0% {
    transform: rotateX(0) rotateY(0) rotateZ(0);
  }
  100% {
    transform: rotateX(360deg) rotateY(360deg) rotateZ(360deg);
  }
}

@keyframes dash {
  to {
    stroke-dashoffset: -120;
  }
}

.benefits {
  &__title {
    width: 70%;
    margin-bottom: 40px;
  }
  
  .terms {
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 190px;

    &__item {
      margin-bottom: 30px;

      &:last-of-type {
        margin-bottom: 0;
      }

      &-content {
        position: relative;
        padding-right: 10px;
        border-bottom: 4px solid $main-color;

        &_1 {
          width: 50%;
          min-width: 140px;
        }

        &_2 {
          width: 100%;
        }

        .currency {
          font-family: 'UniversLTStdBold';
          position: absolute;
          right: 0;
          color: $main-color;
        }
      }
    }

    &__period {
      position: absolute;
      top: 100%;
      left: 60%;
      color: rgba(0, 0, 0, 0.6);

      &:before {
        content: '';
        border-left: 2px dashed #d4e3ec;
        position: absolute;
        left: 50%;
        margin-left: -1px;
        bottom: 100%;
        height: 170px;
      }
    }
  }
}

.diagram-container {
  height: 370px;
  position: relative;
  margin: 10px auto 80px;
  width: 1055px;
  overflow: hidden;

  &.static {
    .circles {
      &__container {
        animation: none !important;
      }
    }
  }

  .circles {
    position: absolute;
    text-align: center;

    &:before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      height: 100%;
    }

    .line {
      position: absolute;
      left: 100%;
      top: 50%;
      height: 3px;
      overflow: hidden;
      margin-top: -2px;
      animation: dash 5s linear infinite;

      svg {
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    &__container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transform-style: preserve-3d;

      .circle {
        position: absolute;
        transform-style: preserve-3d;
        border-radius: 100%;
        border: 2px solid $main-color;

        &:before {
          transform: translateZ(-90px);
        }

        &:after {
          transform: translateZ(90px);
        }
      }
    }

    &__text {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      width: 95%;
      z-index: 1;
    }

    &_1 {
      top: 50%;
      left: 47%;
      height: 265px;
      width: 265px;
      transform: translate3d(-50%, -50%, 0);

      .circles__text {
        font-family: 'UniversLTStdBold';
      }

      .circles__container {
        width: 265px;
        height: 265px;
        margin: 0 auto;
        animation: rotate 30s infinite linear;

        .circle {
          width: 265px;
          height: 265px;

          &:nth-child(1) {
            transform: rotateZ(72deg) rotateX(63.435deg);
          }

          &:nth-child(2) {
            transform: rotateZ(144deg) rotateX(63.435deg);
          }

          &:nth-child(3) {
            transform: rotateZ(288deg) rotateX(63.435deg);
            background: rgba(238, 46, 34, 0.12);
            border: none;
          }

          &:nth-child(4) {
            transform: rotateZ(360deg) rotateX(63.435deg);
            border: 4px solid #ee2e22;
          }
        }
      }
    }

    &_2 {
      top: 0;
      left: 0;
      width: 165px;
      height: 165px;

      .line {
        width: 250px;
      }

      .circles__container {
        width: 165px;
        height: 165px;
        animation: rotate 20s infinite linear forwards;

        .circle {
          width: 165px;
          height: 165px;
          border-color: #d4e3ec;

          &:nth-child(1) {
            transform: rotateZ(72deg) rotateX(63.435deg);
          }

          &:nth-child(2) {
            transform: rotateZ(144deg) rotateX(63.435deg);
            border: 4px solid #d4e3ec;
          }

          &:nth-child(3) {
            transform: rotateZ(216deg) rotateX(63.435deg);
          }

          &:nth-child(4) {
            transform: rotateZ(360deg) rotateX(63.435deg);
            border: 4px solid #d4e3ec;
          }
        }
      }
    }

    &_3 {
      top: 50%;
      left: 17%;
      width: 120px;
      height: 120px;
      transform: translateY(-50%);

      .line {
        width: 70px;
      }

      .circles__container {
        width: 120px;
        height: 120px;
        animation: rotate 20s infinite linear;

        .circle {
          width: 120px;
          height: 120px;

          &:nth-child(1) {
            transform: rotateZ(72deg) rotateX(63.435deg);
          }

          &:nth-child(2) {
            transform: rotateZ(144deg) rotateX(63.435deg);
          }

          &:nth-child(3) {
            transform: rotateZ(288deg) rotateX(63.435deg);
            background: rgba(238, 46, 34, 0.12);
            border: none;
          }

          &:nth-child(4) {
            transform: rotateZ(360deg) rotateX(63.435deg);
          }
        }
      }
    }

    &_4 {
      top: 61%;
      right: 24%;
      width: 140px;
      height: 140px;

      .line {
        width: 95px;
        left: auto;
        right: 100%;
      }

      .circles__container {
        width: 140px;
        height: 140px;
        animation: rotate 20s infinite linear;

        .circle {
          width: 140px;
          height: 140px;
          border-color: #d4e3ec;

          &:nth-child(1) {
            transform: rotateZ(72deg) rotateX(63.435deg);
          }

          &:nth-child(2) {
            transform: rotateZ(144deg) rotateX(63.435deg);
            border-width: 4px;
          }

          &:nth-child(3) {
            transform: rotateZ(216deg) rotateX(63.435deg);
            border-color: #ee2e22;
          }

          &:nth-child(4) {
            transform: rotateZ(360deg) rotateX(63.435deg);
            background: rgba(238, 46, 34, 0.12);
            border: none;
          }
        }
      }
    }

    &_5 {
      top: 50%;
      right: 12%;
      width: 140px;
      height: 140px;
      transform: translateY(-50%);

      .line {
        width: 170px;
        left: auto;
        right: 100%;
      }

      .circles__container {
        width: 140px;
        height: 140px;
        animation: rotate 20s infinite linear;

        .circle {
          width: 140px;
          height: 140px;
          border-color: #d4e3ec;

          &:nth-child(1) {
            transform: rotateZ(72deg) rotateX(63.435deg);
            border-color: #ee2e22;
          }

          &:nth-child(2) {
            transform: rotateZ(144deg) rotateX(63.435deg);
          }

          &:nth-child(3) {
            transform: rotateZ(288deg) rotateX(63.435deg);
            background: rgba(238, 46, 34, 0.12);
            border: none;
          }

          &:nth-child(4) {
            transform: rotateZ(360deg) rotateX(63.435deg);
            border-width: 4px;
          }
        }
      }
    }

    &_6 {
      top: 0;
      right: 0;
      width: 140px;
      height: 140px;

      .line {
        width: 360px;
        left: auto;
        right: 100%;
      }

      .circles__container {
        width: 140px;
        height: 140px;
        animation: rotate 20s infinite linear;

        .circle {
          width: 140px;
          height: 140px;
          border-color: #d4e3ec;

          &:nth-child(1) {
            transform: rotateZ(72deg) rotateX(63.435deg);
            border-width: 4px;
          }

          &:nth-child(2) {
            transform: rotateZ(144deg) rotateX(63.435deg);
            background: rgba(238, 46, 34, 0.12);
            border: none;
          }

          &:nth-child(3) {
            transform: rotateZ(216deg) rotateX(63.435deg);
          }

          &:nth-child(4) {
            transform: rotateZ(360deg) rotateX(63.435deg);
            border-color: #ee2e22;
          }
        }
      }
    }

  }
}

@media (max-width: 850px) {
  .benefits {
    &__title {
      width: 100%;
    }
  }
}

@media (max-width: 1280px) {
  .diagram-container {
    width: 890px;

    .circles {
      .line {

      }

      &_2 {
        .line {
          width: 170px;
        }
      }

      &_3 {
        left: 15%;

        .line {
          width: 20px;
        }
      }

      &_4 {
        .line {
          width: 45px;
        }
      }

      &_5 {
        .line {
          width: 95px;
        }
      }

      &_6 {
        .line {
          width: 275px;
        }
      }
    }
  }
}

@media (max-width: 1100px) {
  .diagram-container {
    height: 1100px;
    width: 270px;
    margin: 10px auto 80px;

    .circles {
      .line {
        position: absolute;
        left: 50%;
        top: 100%;
        transform: rotate(90deg);
        transform-origin: left;
      }

      &_1 {
        left: 0;
        top: 380px;
        transform: translate(0, 0);
      }

      &_2 {
        top: 0;
        left: 0;

        .line {
          width: 230px;
        }
      }

      &_3 {
        top: 210px;
        left: 130px;
        transform: translateY(0);

        .line {
          width: 70px;
        }
      }

      &_4 {
        top: 710px;
        left: 0;

        .line {
          width: 95px;
          top: auto;
          bottom: 90%;
          left: auto;
          right: 50%;
          transform-origin: right;
        }
      }

      &_5 {
        top: 880px;
        right: auto;
        left: 130px;

        .line {
          width: 180px;
          top: auto;
          bottom: 100%;
          left: auto;
          right: 50%;
          transform-origin: right;
        }
      }

      &_6 {
        top: 950px;
        left: 66px;
        right: auto;

        .line {
          width: 330px;
          top: auto;
          bottom: 90%;
          left: auto;
          right: 50%;
          transform-origin: right;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/PrivateEquityContent.vue?06c030dc